import React, { useEffect, useRef, useState } from 'react';

const isMobile = () => {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};

const IntroVideo = ({ onFinish }) => {
  const [fadeOut, setFadeOut] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    if (isMobile()) {
      // Immediately skip the intro on mobile
      setHidden(true);
      onFinish();
      return;
    }

    setShowVideo(true);

    const video = videoRef.current;
    if (video) {
      video.play().catch(() => {
        // Ignore autoplay blocking
      });
    }

    const handleFinish = () => {
      setFadeOut(true);
      setTimeout(() => {
        setHidden(true);
        onFinish();
      }, 300);
    };

    const timer = setTimeout(() => {
      handleFinish();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onFinish]);

  if (hidden || !showVideo) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black flex items-center justify-center">
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        preload="auto"
        disablePictureInPicture
        onEnded={() => setFadeOut(true)}
        className={`object-contain max-w-screen-md max-h-[480px] w-full h-full transition-opacity duration-500 ${
          fadeOut ? 'opacity-0' : 'opacity-100'
        }`}
        onTransitionEnd={() => {
          if (fadeOut) {
            setHidden(true);
            onFinish();
          }
        }}
      >
        <source src="/Video.mp4" type="video/mp4" />
      </video>
    </div>
  );
};

export default IntroVideo;
